// Types
import type { TApiHttpClientRequestConfig } from '~/misc/resource/types';
import type { TWrappedFilters } from '~/misc/listings/types';
import type { TAutomatedEmailSaleType } from '~/modules/opportunities/automated-email/types';
import type { TWrappedPatchFilters } from '~/modules/opportunities/automated-email/settings/utils/build-patch-filters-payload';

// Models
import { DefaultResource } from '~/misc/resource/default-resource.model';

export class PatchFiltersModel extends DefaultResource {
  protected endpoint: string = 'automated-email/';

  getPatchFilters(
    patchId: number,
    saleType: TAutomatedEmailSaleType,
    requestConfig?: TApiHttpClientRequestConfig
  ): Promise<TWrappedFilters> {
    return this.get<TWrappedFilters>(
      'patch-filters',
      { patch_id: patchId, sale_type: saleType },
      requestConfig
    );
  }

  savePatchFilters(
    patchId: number,
    saleType: TAutomatedEmailSaleType,
    filters: TWrappedPatchFilters,
    requestConfig?: TApiHttpClientRequestConfig
  ): Promise<TWrappedFilters> {
    return this.post<TWrappedFilters>(
      'patch-filters',
      { patch_id: patchId, sale_type: saleType, filters },
      requestConfig
    );
  }
}
